import React from 'react';
import {
  Dialog,
  DialogProps,
  DialogTitle,
  DialogTitleProps,
  DialogContent,
  DialogContentText,
  DialogContentTextProps,
  DialogActions,
  Button,
  ButtonProps,
} from '@mui/material';

export interface IButtonProps extends ButtonProps {
  label?: string;
}

export interface ISimpleConfirmationAlert {
  open: boolean;
  onClose: DialogProps['onClose'];
  title: string;
  titleProps?: DialogTitleProps;
  description?: string;
  descriptionProps?: DialogContentTextProps;
  cancelButtonProps?: IButtonProps;
  okButtonprops?: IButtonProps;
}

const SimpleConfirmationAlert: React.FC<ISimpleConfirmationAlert> = ({
  open,
  onClose,
  title,
  titleProps,
  description,
  descriptionProps,
  okButtonprops,
  cancelButtonProps,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="simple-confirmation-alert-title"
      aria-describedby="simple-confirmation-alert-description"
    >
      <DialogTitle id="simple-confirmation-alert-title" {...titleProps}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="simple-confirmation-alert-description"
          {...descriptionProps}
        >
          {description}
        </DialogContentText>
      </DialogContent>
      {(cancelButtonProps || okButtonprops) && (
        <DialogActions>
          {cancelButtonProps && (
            <Button color="info" {...cancelButtonProps}>
              {cancelButtonProps.label}
            </Button>
          )}
          {okButtonprops && (
            <Button color="info" {...okButtonprops}>
              {okButtonprops.label}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default SimpleConfirmationAlert;
